import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Colaborador } from 'src/app/shared/models/colaborador.model';
import { Usuario } from 'src/app/shared/models/usuario.model';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { ToastService } from 'src/app/shared/toast';
import BrowserUtils from 'src/app/shared/utils/browser-utils';
import { environment } from 'src/environments/environment';
import { AutenticacaoService } from './../../seguranca/autenticacao.service';
import { AutorizacaoCertificadoModalComponent } from './autorizacao-certificado-modal/autorizacao-certificado-modal.component';
import { Bandeira } from 'src/app/shared/models/bandeira.enum';

const assets = {
  cb: {
    brand: 'assets/images/new-brand-cb.svg',
    brandVert: 'assets/images/login/cb-brand-vert.svg',
    brandMascot: 'assets/images/login/cb-login-section.png',
  },
  pf: {
    brand: 'assets/images/new-brand-pf.svg',
    brandVert: 'assets/images/login/pf-brand-vert.svg',
    brandMascot: 'assets/images/login/pf-login-section.png',
  }
}

@Component({
  selector: 'app-colaborador-authentication-page',
  templateUrl: './colaborador-authentication-page.component.html',
  styleUrls: ['./colaborador-authentication-page.component.scss']
})
export class ColaboradorAuthenticationPageComponent implements OnInit {

  loader = false;
  colaboradorLogado: Colaborador | null = null;
  urlAutorizacao = `${this.apiUrlService}/v1/cobranca-orquestrador-registro`;
  isMinorThanTablet: Observable<BreakpointState> = this.breakpointObserver.observe('(max-width: 768px)');
  isCasasBahia: boolean;

  constructor(
    private router: Router,
    private autenticacaoService: AutenticacaoService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private dialog: MatDialog,
    private breakpointObserver: BreakpointObserver,
    private toastService: ToastService,
  ) { }

  ngOnInit(): void {
    this.isCasasBahia = this.autenticacaoService.bandeira === Bandeira.CASAS_BAHIA;

    // if (BrowserUtils.isOldFirefox()) {
    //   this.autorizarCertificado();
    // }

    this.googleAnalyticsService.pushNavigateEvent('/renegociacao/acesso/colaborador/login');
    this.colaboradorLogado = this.autenticacaoService.colaboradorAutenticado;
  }

  logoutColaborador(): void {
    this.autenticacaoService.logout();
    this.colaboradorLogado = null;
  }

  async loginColaborador(colaborador: Colaborador): Promise<void> {
    try {
      this.loader = true;
      await this.autenticacaoService.loginColaborador(colaborador);
      this.colaboradorLogado = colaborador;
      this.googleAnalyticsService.pushNavigateEvent('/renegociacao/acesso/colaborador/login_cliente');
    } catch (response) {
      if (response?.error?.message) {
        this.toastService.show({ title:  response.error.message, type: 'error' });
      } else { 
        this.toastService.show({ title: 'Não foi possível fazer a autenticação.', text: 'Por favor, verifique suas credenciais ou tente novamente mais tarde.', type: 'error' });
      }
    } finally {
      this.loader = false;
    }
  }

  async loginUsuario(usuario: Usuario): Promise<void> {
    try {
      this.loader = true;
      await this.autenticacaoService.loginColaborador(this.colaboradorLogado, usuario);
      this.router.navigate(['/portal']);
    } catch (response) {
      if (response?.error?.message) {
        this.toastService.show({ title:  response.error.message, type: 'error' });
      } else {
        this.toastService.show({ title: 'Não foi possível fazer a autenticação.', text: 'Por favor, verifique as credenciais do cliente ou tente novamente mais tarde.', type: 'error' });
      }
    } finally {
      this.loader = false;
    }
  }

  async autorizarCertificado() {
    try {
      await this.autenticacaoService.consultaAutorizacaoCertificado();
    } catch (error) {
      this.dialog.open(AutorizacaoCertificadoModalComponent, { disableClose: false });
    }
  }

  get apiUrlService(): string {
    if (BrowserUtils.isOldFirefox()) {
      return environment.cdccorpApiURLService;
    }

    return environment.apiURLService;
  }


  get isOldFirefox() {
    return BrowserUtils.isOldFirefox();
  }

  get assets() {
    if (this.isCasasBahia) {
      return assets.cb;
    }

    return assets.pf;
  }
}
